import useCustomTranslation from 'hooks/useCustomTranslation'
import LanguageButton from 'ui/atoms/LanguageButton'
import { HeaderContainer, HeaderText, LogoImg } from './Header.styles'

const Header = (): JSX.Element => {
  const t = useCustomTranslation('header')

  return (
    <HeaderContainer>
      <LogoImg alt="Synchrony Logo" />
      <HeaderText>{t('title')}</HeaderText>
      <LanguageButton />
    </HeaderContainer>
  )
}

export default Header
